import React from 'react';
import { Box } from '../../../../../Box';
import { dataTableClassnames } from '../../../const/classNames';
import { DataTableTypes } from '../../../../DataTableTypes';
import { OverFlowMenu } from '../../../../../OverFlowMenu';
import { TokenColor } from '../../../../../../setup/theme/impl/colors';

interface MenuCellProps {
  dataTest: string | undefined;
  style: React.CSSProperties | undefined;
  actions: DataTableTypes.MenuColumn<any>['actions'];
  data: DataTableTypes.DataModel;
}

export const MenuCell: React.FC<MenuCellProps> = ({ style, dataTest, actions, data }) => {
  const mappedActions = actions
    ?.filter((action) => !booleanOrFunctionToBoolean(action.hidden, data))
    .map((action) => ({
      color: action.red ? ('colorAlert' as TokenColor) : undefined,
      icon: action.iconName,
      disabled: booleanOrFunctionToBoolean(action.disabled, data),
      run: () => action.onClick(data),
      dataTest: action.dataTest,
      label: typeof action.label === 'function' ? action.label(data) : action.label
    }));
  return (
    <Box
      display="flex"
      className={dataTableClassnames.table.row.actions}
      alignItems="center"
      dataTest={dataTest}
      style={style}
    >
      <OverFlowMenu disabled={!mappedActions?.length} actions={mappedActions} />
    </Box>
  );
};

export function booleanOrFunctionToBoolean<T>(
  value: undefined | boolean | ((data: T) => boolean),
  data: T
): boolean | undefined {
  if (typeof value === 'undefined') {
    return undefined;
  }
  if (typeof value === 'boolean') {
    return value;
  }
  return value(data);
}
